var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenCorrect = function SvgGreenCorrect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uF122")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11-About-&-Business-pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.2-HY-Business",
    transform: "translate(-235.000000, -536.000000)",
    fill: "#00983F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-+-Welcome-to-Hala-Yall-+-Group-2-Mask",
    transform: "translate(-0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cheerful-african-american-with-crisp-hair-holds-modern-smart-phone-happy-smile-+-Group-Mask",
    transform: "translate(0.000000, 272.971647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(200.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(25.350000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0957792,27 C15.1582792,27 15.2520292,26.9375 15.3770292,26.8125 L15.3770292,26.8125 L23.1582792,16.8125 C23.1999459,16.7291667 23.2207792,16.6666667 23.2207792,16.625 C23.2207792,16.5833333 23.1999459,16.5208333 23.1582792,16.4375 L23.1582792,16.4375 L21.4395292,15.0625 C21.3561959,15.0208333 21.2832792,15 21.2207792,15 C21.1374459,15 21.0749459,15.0208333 21.0332792,15.0625 L21.0332792,15.0625 L14.7832792,23.09375 L12.2832792,20.65625 C12.1582792,20.53125 12.0541126,20.46875 11.9707792,20.46875 C11.9291126,20.46875 11.8457792,20.53125 11.7207792,20.65625 C11.3874459,20.9895833 10.9291126,21.46875 10.3457792,22.09375 L10.3457792,22.09375 L10.2832792,22.15625 C10.2416126,22.2395833 10.2207792,22.2916667 10.2207792,22.3125 C10.2207792,22.3541667 10.2416126,22.4166667 10.2832792,22.5 L10.2832792,22.5 L10.3770292,22.59375 L14.7832792,26.84375 C14.8874459,26.9479167 14.9916126,27 15.0957792,27 Z",
    id: "\\uF122"
  })))))))));
};
export default SvgGreenCorrect;